/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable react/jsx-key */
// @ts-uncheck
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState, useEffect } from 'react'
import { Box, Button, Divider } from '@mui/material'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import { useStyles } from './inboxStyles'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Clear as ClearIcon } from '@mui/icons-material'
import BlockIcon from '@mui/icons-material/Block'

const LaunchMaskedModal = ({ caseId, patientName, trfId, handleClose, handleStart, handleComplete, workflow }) => {
  const classes = useStyles()
  const [buttonCheck, setButtonCheck] = useState(false)

  useEffect(() => {
    if (workflow != (13 || 2)) {
      setButtonCheck(true)
    } else {
      setButtonCheck(false)
    }
  }, [workflow])

  return (
    <Box className={`${classes.mt} , ${classes.mb}`}>
      <Dialog maxWidth={false} id="hello" open={true} onClose={handleClose} classes={{ paper: classes.dialogHeight }}>
        <DialogTitle className={classes.dialogTitle}>Case diagnosis</DialogTitle>
        <Divider />
        <DialogContent sx={{ width: '715px' }}>
          <p>
            <BlockIcon style={{ color: 'red', verticalAlign: 'middle', marginRight: '10px' }} />
            Sorry! You cannot perform Case Diagnosis while waiting for the slides.
          </p>
        </DialogContent>
        <DialogActions className={classes.buttonActions}>
          <Button
            onClick={handleClose}
            variant="outlined"
            style={{ textTransform: 'none' }}
            size="medium"
            endIcon={<ClearIcon />}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}
export default LaunchMaskedModal
